<div class="wrapper">
    <section class="container">

        <div class="row features justify-content-center">
            <section class="col-12 col-12-narrower feature text-start">

                <header class="major">
                    <h2 i18n>Migration von JUnit 4 zu JUnit 5 in Java und Spring-Anwendungen</h2>
                </header>

                <table>
                    <tr>
                        <th i18n>JUnit 4 Annotation</th>
                        <th i18n>JUnit 5 Entsprechung</th>
                        <th i18n>Spring-spezifische Anmerkungen</th>
                    </tr>
                    <tr>
                        <td i18n>&#64;Before</td>
                        <td i18n>&#64;BeforeEach</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td i18n>&#64;After</td>
                        <td i18n>&#64;AfterEach</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td i18n>&#64;BeforeClass</td>
                        <td i18n>&#64;BeforeAll</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td i18n>&#64;AfterClass</td>
                        <td i18n>&#64;AfterAll</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td i18n>&#64;Ignore</td>
                        <td i18n>&#64;Disabled</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td i18n>&#64;Test (expected = Exception.class)</td>
                        <td i18n>&#64;Test<br>{{'assertThrows(Exception.class, () -> {...})'}}</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td i18n>&#64;Test (timeout = 100)</td>
                        <td i18n>&#64;Test<br>{{'assertTimeout(Duration.ofMillis(100), () -> {...})'}}</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td i18n>&#64;RunWith(SpringJUnit4ClassRunner.class)</td>
                        <td i18n>&#64;ExtendWith(SpringExtension.class)</td>
                        <td i18n>Ersetzt für Spring-Integration</td>
                    </tr>
                    <tr>
                        <td i18n>&#64;ContextConfiguration(classes = MyConfig.class)</td>
                        <td i18n>&#64;SpringJUnitConfig(MyConfig.class)</td>
                        <td i18n>&#64;SpringJUnitConfig(MyConfig.class) ersetzt in Kombination die
                            &#64;ExtendWith(SpringExtension.class) und &#64;ContextConfiguration(classes = MyConfig.class) in
                            JUnit 5, was die Testklasse übersichtlicher macht.</td>
                    </tr>
                    <!-- Weitere Zeilen können hier hinzugefügt werden -->
                </table>

            </section>
        </div>
    </section>

</div>